/**
 * Aviso de defasagem — diz a idade do que está na tela.
 *
 * As telas de atendimento leem cópias locais do ERP (ADR 0009), o que mantém o
 * CRM de pé quando o Oracle cai. O efeito colateral é que, se o sync parar, a
 * tela continua servindo o último estado com cara de estado atual — e aí uma
 * queda invisível vira decisão tomada com dado velho.
 *
 * Este componente só aparece quando há algo defasado. Silêncio aqui significa
 * "o dado é de hoje", e é por isso que ele não pode virar banner permanente.
 */
import React, { useEffect, useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import api from '../services/api';

export default function AvisoDefasagem() {
  const [estado, setEstado] = useState(null);

  useEffect(() => {
    let vivo = true;
    api.get('/diagnostico/frescor')
      .then(({ data }) => { if (vivo) setEstado(data); })
      // Falha no próprio aviso não deve gritar na tela do atendente.
      .catch(() => {});
    return () => { vivo = false; };
  }, []);

  if (!estado?.alguma_defasada) return null;

  const problemas = estado.copias.filter(c => !c.existe || c.defasado);
  const descrever = (c) => {
    if (!c.existe) return `${c.rotulo}: nunca sincronizado`;
    if (c.horas == null) return `${c.rotulo}: sem data de sincronização`;
    const dias = Math.floor(c.horas / 24);
    const idade = dias >= 1 ? `${dias} ${dias === 1 ? 'dia' : 'dias'}` : `${Math.round(c.horas)}h`;
    return `${c.rotulo}: ${idade} atrás`;
  };

  return (
    <div style={{
      display: 'flex', alignItems: 'flex-start', gap: '10px',
      background: '#fef5e7', border: '1px solid #f0d9a8', borderRadius: '10px',
      padding: '12px 14px', marginBottom: '16px', fontSize: '0.85rem', color: '#8a6d1f',
    }}>
      <AlertTriangle size={16} color="#f39c12" style={{ marginTop: '1px', flexShrink: 0 }} />
      <div>
        <strong>Dado desatualizado nesta tela.</strong>{' '}
        A sincronização com o ERP não roda desde{' '}
        {problemas.length === 1 ? 'o horário abaixo' : 'os horários abaixo'}.
        Confirme no ERP antes de decidir com base no que está aqui.
        <div style={{ marginTop: '6px', color: '#6b5518' }}>
          {problemas.map(descrever).join(' · ')}
        </div>
      </div>
    </div>
  );
}
